import { Dialog, Icons } from '@mnd-frontend/ui';
import { useContext } from 'react';
import { SystemDialogContext } from '../../../../contexts/SystemDialogContext';

const SystemDialog = () => {
  const {
    state: { show, labelConfirm, onConfirm, title, message },
    close,
  } = useContext(SystemDialogContext);

  return (
    <Dialog
      open={show}
      onClose={close}
      icon={<Icons.TriangleWarning $size="sm" $color="colorIconsWarning" />}
      headline={title}
      description={message || ''}
      confirmAction={{
        onClick: onConfirm,
        text: labelConfirm,
      }}
    />
  );
};

export default SystemDialog;
